import { Alert } from 'react-bootstrap';
import { useState } from 'react';
import { Avatar } from '@mui/material';
import ClientCard from 'views/Dashboard/ClientCard';

function ClientCardList(props) {
  const {
    clients,
    statusList,
    group,
    staff,
    callSettingsModal,
    callNyukinCommentModal,
    callSortModal,
  } = props;

  const [hover, setHover] = useState(false);

  const statusCodes = statusList.map((s) => s.id);

  const filteredClients = clients
    .filter((c) => statusCodes.includes(c.CONSTRUCTION_STATUS))
    .sort((a, b) => (a.SORT > b.SORT ? 1 : -1));

  const primaryStatus = statusList[0];

  // 並べ替えボタン
  const handleOnClickSort = (e) => {
    e.preventDefault();
    callSortModal({
      clients: [...filteredClients],
      statusName: group.DISPLAY,
      staff: staff,
      fixCallback: (data) => {
        props.setClients?.([
          ...clients.filter((c) => !data.some((d) => c.SEIKYU_NO == d.SEIKYU_NO)),
          ...data,
        ]);
      },
    });
  };

  return (
    <div className="flex-fill p-0 m-0 mr-2" style={{ width: '308px' }}>
      <Alert
        style={{
          color: primaryStatus.FONT_COLOR,
          background: primaryStatus.COLOR,
          width: '308px',
        }}
        className="m-0 p-0 d-flex flex-row justify-content-between align-items-center rounded"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <div className="d-flex p-2 align-items-center">
          <i className="material-symbols-rounded">{primaryStatus.ICON}</i>
          <h4 className="m-0 p-0 pl-2">{group.DISPLAY}</h4>
        </div>
        <a href="#" onClick={handleOnClickSort}>
          <Avatar
            className="mr-2"
            sx={{ width: 32, height: 32, bgcolor: '#8946ff' }}
            hidden={!hover || filteredClients.length == 0}
          >
            <i className="material-symbols-rounded">sort</i>
          </Avatar>
        </a>
      </Alert>

      {filteredClients.map((c) => (
        <ClientCard
          key={c.SEIKYU_NO}
          client={c}
          callSettingsModal={callSettingsModal}
          callNyukinCommentModal={callNyukinCommentModal}
        />
      ))}
    </div>
  );
}

export default ClientCardList;
